import type { Editor } from "@tiptap/core";
import type { Owner } from "solid-js";

export const ReactiveOwnerProperty = Symbol("Reactive owner property used by TipTap solid as a workaround");

export const getTipTapSolidReactiveOwner = (editor: Editor): Owner | undefined =>
  // @ts-expect-error yes, we know 'ReactiveOwnerProperty' does not exist
  editor[ReactiveOwnerProperty] ?? undefined;

export const setTipTapSolidReactiveOwner = (editor: Editor, owner: Owner) =>
  // @ts-expect-error yes, we know 'ReactiveOwnerProperty' does not exist
  (editor[ReactiveOwnerProperty] = owner);
